(function() {
  'use strict';

  var slider = document.querySelector('[data-hero-slider]');
  if (!slider) return;

  var slides = slider.querySelectorAll('.hero-slider__slide');
  var dots = slider.querySelectorAll('[data-hero-dot]');
  var prevBtn = slider.querySelector('[data-hero-prev]');
  var nextBtn = slider.querySelector('[data-hero-next]');
  var currentIndex = 0;
  var autoplayInterval;
  var speed = (slider.closest('section')?.dataset?.autoplaySpeed || 5) * 1000;

  function goToSlide(index) {
    slides[currentIndex].classList.remove('is-active');
    if (dots[currentIndex]) dots[currentIndex].classList.remove('is-active');
    currentIndex = (index + slides.length) % slides.length;
    slides[currentIndex].classList.add('is-active');
    if (dots[currentIndex]) dots[currentIndex].classList.add('is-active');
  }

  function nextSlide() { goToSlide(currentIndex + 1); }
  function prevSlide() { goToSlide(currentIndex - 1); }

  function startAutoplay() {
    stopAutoplay();
    autoplayInterval = setInterval(nextSlide, speed);
  }
  function stopAutoplay() { clearInterval(autoplayInterval); }

  if (prevBtn) prevBtn.addEventListener('click', function() { prevSlide(); startAutoplay(); });
  if (nextBtn) nextBtn.addEventListener('click', function() { nextSlide(); startAutoplay(); });
  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      goToSlide(parseInt(dot.dataset.heroDot, 10));
      startAutoplay();
    });
  });

  // Touch/swipe support
  var touchStartX = 0;
  var touchEndX = 0;
  var touchStartY = 0;
  var touchEndY = 0;
  var isSwiping = false;

  slider.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
    touchStartY = e.changedTouches[0].screenY;
    isSwiping = true;
    stopAutoplay();
  }, { passive: true });

  slider.addEventListener('touchmove', function(e) {
    if (!isSwiping) return;
    var diffX = Math.abs(e.changedTouches[0].screenX - touchStartX);
    var diffY = Math.abs(e.changedTouches[0].screenY - touchStartY);
    // If horizontal swipe is dominant, prevent vertical scroll
    if (diffX > diffY && diffX > 10) {
      e.preventDefault();
    }
  }, { passive: false });

  slider.addEventListener('touchend', function(e) {
    if (!isSwiping) return;
    isSwiping = false;
    touchEndX = e.changedTouches[0].screenX;
    touchEndY = e.changedTouches[0].screenY;
    var diffX = touchStartX - touchEndX;
    var diffY = Math.abs(touchStartY - touchEndY);
    // Only trigger if horizontal swipe > 50px and more horizontal than vertical
    if (Math.abs(diffX) > 50 && Math.abs(diffX) > diffY) {
      if (diffX > 0) {
        nextSlide();
      } else {
        prevSlide();
      }
    }
    startAutoplay();
  }, { passive: true });

  if (slides.length > 1) startAutoplay();

  slider.addEventListener('mouseenter', stopAutoplay);
  slider.addEventListener('mouseleave', startAutoplay);
})();
